"use strict";

function lazyLoad(){
	if ("IntersectionObserver" in window) {
		const lazyObserver = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry){
				if (entry.isIntersecting) {
					entry.target.src = entry.target.dataset.src;
					entry.target.classList.remove("lazy");
					lazyObserver.unobserve(entry.target);
				}
			});
		}, { root: null});
		document.querySelectorAll(".lazy").forEach(function(image){lazyObserver.observe(image)});
	} 
	else {
		let lazyTimeOut;
		let imageList=document.querySelectorAll(".lazy");
		function lazyLoad () {
			if(lazyTimeOut) clearTimeout(lazyTimeOut);
			lazyTimeOut = setTimeout(function(){
				Array.prototype.slice.call(imageList).forEach(function (element) {
					if(element.getBoundingClientRect().top < window.innerHeight + window.scrollY || document.documentElement.scrollTop) {
						element.setAttribute("src", element.getAttribute("data-src"));
						element.classList.remove("lazy");
						imageList = document.querySelectorAll(".lazy");
					}
				});
				if(imageList.length == 0) {
					$(document).off("scroll");
					$(window).off("resize");
				}
			}, 20);
		}
		$(document).on("scroll", lazyLoad.bind(this));
		$(window).on("resize", lazyLoad.bind(this));
	}
}

if(document.addEventListener){
	document.addEventListener("DOMContentLoaded", function(){if(document.readyState === "interactive") lazyLoad();}, false );
}else if(document.attachEvent){
 	document.attachEvent("onreadystatechange", function(){if(document.readyState === "interactive") lazyLoad();});
}

document.oncontextmenu = document.body.oncontextmenu = function() {return false;}

var main = {
	navigation: function () {
		var navTimer;
		var navMenu = $("header nav .nav-menu");

		$("> li", navMenu).each(function (index, menuItem) {
			var id = $(menuItem).data("id");
			var url = $(menuItem).data("url");

			$.ajax({
				url: url,
				type: "GET",
				data: {
					id: id
				}
			})
				.done(function (response) {
					var responseHtml = $.parseHTML(response);

					$(menuItem).append(responseHtml);
					lazyLoad();
					$(menuItem).on({
						mouseenter: function () {
							var $this= $(this);

							if (window.matchMedia("(min-width: 992px)").matches) {
								$(window).on("mousemove", function (event) {
									clearTimeout(navTimer);

									navTimer = setTimeout(function () {
										var width = $this.outerWidth();
										var left = $this.offset().left;

										$("header .indicator").stop().animate({
											width: width,
											left: left
										}, 300, "easeOutExpo");

										$(".search-container input[type='text']").blur().focus();

										$("> li", navMenu).removeClass('hover');
										$this.addClass('hover');
									}, 50);
								});
							} else {
								$("> li", navMenu).removeClass('hover');
							}
						},
						mouseleave: function () {
							var $this = $(this);

							if (window.matchMedia("(min-width: 992px)").matches) {
								$(window).on("mousemove", function (event) {
									clearTimeout(navTimer);

									navTimer = setTimeout(function () {
										$("header .indicator").stop().animate({
											width: 0
										}, 300, "easeOutExpo");
										$this.removeClass('hover');

									}, 50);
								});
							}
						}
					});

					$(".sub-nav", menuItem).each(function (index, element) {
						$(".sub-menu > ul > li", element).first().addClass("active");
					});
				});
		});

		navMenu.on("mouseenter", "> li", function () {
			var $this= $(this);

			if (window.matchMedia("(min-width: 992px)").matches) {
				$(window).on("mousemove", function (event) {
					clearTimeout(navTimer);

					navTimer = setTimeout(function () {
						var width = $this.outerWidth();
						var left = $this.offset().left;

						$("header .indicator").stop().animate({
							width: width,
							left: left
						}, 300, "easeOutExpo");

						$(".search-container input[type='text']").blur().focus();

						$("> li", navMenu).removeClass('hover');
						$this.addClass('hover');
					}, 50);
				});
			} else {
				$("> li", navMenu).removeClass('hover');
			}
		});

		navMenu.on("mouseleave", "> li", function () {
			var $this = $(this);

			if (window.matchMedia("(min-width: 992px)").matches) {
				$(window).on("mousemove", function (event) {
					clearTimeout(navTimer);

					navTimer = setTimeout(function () {
						$("header .indicator").stop().animate({
							width: 0
						}, 300, "easeOutExpo");
						$this.removeClass('hover');

					}, 50);
				});
			}
		});

		navMenu.on("click", "> li > a", function (event) {
			if (window.matchMedia('(min-width: 992px)').matches && $("html").hasClass("touchevents") && !$(this).hasClass("go-link")) {
				$("> li > a", navMenu).removeClass("go-link");
				$(this).addClass("go-link");

				event.preventDefault();
			}
		});

		navMenu.on("mouseenter", ".sub-nav .sub-menu > ul > li > a", function (event) {
			if ($(window).width() >= 992) {
				$(this).parents(".sub-nav").find(".sub-menu > ul > li").removeClass("active");
				$(this).parent().addClass("active");

				event.preventDefault();
			}
		});

		navMenu.on("click", "> li:not(.single) > a", function (event) {
			if ($(window).width() < 992) {
				if ($(this).hasClass("active")) {
					$(this).removeClass("active");
					$(this).next(".sub-nav").stop().slideUp(300);
				} else {
					$("> li > a", navMenu).removeClass("active");
					$("> li > .sub-nav", navMenu).stop().slideUp(300);

					$(this).addClass("active");
					$(this).next(".sub-nav").stop().slideDown(300);
				}

				event.preventDefault();
			}
		});

		$(window).on({
			scroll: function () {
				var trigger = 0;

				if ($(".module-slider-main").length) {
					trigger = 3000;
				}

				if ($(window).scrollTop() > trigger) {
					$("header").addClass("sticky");
				} else {
					$("header").removeClass("sticky");
				}
			}
		});

		$("header .bar .bar-button").on({
			click: function () {
				$("header").removeClass("collapsed");
				$(".module-content-nav.has-sticky").addClass("menu-opened");

				if ($(window).width() <= 768) {
					$("header .menu-button").trigger("click");
				}
			}
		});

		$("header .menu-button").on({
			click: function () {
				$("header nav").addClass("opened");
				$("header .nav-overlay").addClass("opened");
			}
		});

		$("header nav .nav-header .close").on({
			click: function () {
				$("header nav").removeClass("opened");
				$("header .nav-overlay").removeClass("opened");
			}
		});

		$(window).on({
			resize: function () {
				if ($(window).width() >= 992) {
					$("> li > a", navMenu).removeClass("active");
					$("> li > .sub-nav", navMenu).removeAttr("style");
					$("header nav").removeClass("opened");
					$("header .nav-overlay").removeClass("opened");
				}
			}
		});
	},
	newsletter: function () {
		var lang = $("html").attr("lang");

		$(".module-newsletter form").validate({
			ignore: [],
			onkeyup: false,
			highlight: function(element, errorClass, validClass) {
				$(element).parent().addClass(errorClass).removeClass(validClass);
			},
			unhighlight: function(element, errorClass, validClass) {
				$(element).parent().removeClass(errorClass).addClass(validClass);
			},
			submitHandler: function (form) {
				var url = $(form).attr("action");
				var type = $(form).attr("method") || "GET";
				var data = $(form).serialize();
				$("input[type='submit']", form).attr("disabled", true);

				$(form).addClass("loading");

				$.ajax({
					url: url,
					type: type,
					dataType: "json",
					data: data,
					success: function (response) {
						$(form).removeClass("loading");
						$("input[type='submit']", form).removeAttr("disabled");

						if (response.status == 1) {
							$(".module-newsletter .text, .module-newsletter .form").hide();
							$(".module-newsletter .result p").html(response.messages);
							$(".module-newsletter .result").show();
							$(".module-newsletter .form .form-input label.error").remove();
						} else {
							$(".module-newsletter .form .form-input input").addClass("error");
							$(".module-newsletter .form .form-input").append("<label class='error'>" + response.messages + "</label>");
						}
					}
				});
			},
			rules: {
				email: {
					required: true,
					email: true
				},
				ticariElektronik: {
					required: true
				},
				aydinlatmaMetni: {
					required : true
				},
				acikRizaMetni: {
					required : true
				}
			},
			messages: {
				email: {
					required: main.localization[lang][0],
					email: main.localization[lang][1]
				}
			}
		});

		$(".module-newsletter form input[type='text']").on({
			keydown: function () {
				$(this).removeClass("error");
				$(this).next("label.error").remove();
			}
		});

		$(".page-newsletter .form form").validate({
			highlight: function(element, errorClass, validClass) {
				$(element).parent().addClass(errorClass).removeClass(validClass);
			},
			unhighlight: function(element, errorClass, validClass) {
				$(element).parent().removeClass(errorClass).addClass(validClass);
			},
			rules: {
				name: "required",
				surname: "required"
			},
			messages: {
				name: "Lütfen adınızı girin",
				surname: "Lütfen soyadınızı girin"
			}
		});
	},
	sliders: {
		main: {
			controller: null,
			scene: null,
			init: function () {
				$(".module-slider-main .slider, .module-slider-main .mobile-slider .item").css({
					height: $(window).height() - $("header").height()
				});

				if ($(window).width() >= 768) {
					if ($(".module-slider-main").length && !$(".module-slider-main").hasClass("scrollmagic-active")) {
						$("html, body").scrollTop(0);
						$(".module-slider-main").addClass("scrollmagic-active");
						main.sliders.main.create();
					}
				} else {
					$(".module-slider-main").removeClass("scrollmagic-active");
					main.sliders.main.destroy();
				}
			},
			create: function () {
				main.sliders.main.controller = new ScrollMagic.Controller();
				var tween = new TimelineMax();
				var slider = ".module-slider-main .slider";
				var text = $(".content-text", slider);
				var controls = $(".controls", slider);
				var items = $(".item", slider);
				var spacer = $(".slider-spacer");
				var spacerInner = $(".slider-spacer-inner");
				var offset = $(slider).height() / 2;
				var duration = 3000;

				$(".pager", controls).html("");

				items.each(function (index, item) {
					// z-index
					$(item).css({
						zIndex: items.length - index
					});

					// controls
					$(".pager", controls).append("<li><span></span></li>");

					// tween
					if (index < items.length - 1) {
						tween.to(item, .3, {
							y: "-30%",
							ease: Power0.easeNone
						})
						.to(item, .7, {
							y: "-100%",
							opacity: 0,
							ease: Power0.easeNone
						})
						.to(item, .5, {
							opacity: 0,
							ease: Power0.easeNone
						});
					}
				});

				var scene = new ScrollMagic.Scene({
					duration: duration,
					triggerHook: 0,
					// triggerElement: slider
				})
				.setTween(tween)
				.setPin(slider)
				.addTo(main.sliders.main.controller);

				main.sliders.main.scene = scene;

				function getActive () {
					var sliderTop = Math.ceil($(slider).offset().top);
					var active;

					items.each(function (index, item) {
						if (sliderTop - $(item).offset().top < offset) {
							active = index;

							return false;
						}
					});

					return active;
				}

				function goTo (index) {
					var step = duration / (items.length - 1);
					var scrollTop = index * step;

					$("html, body").stop().animate({
						scrollTop: scrollTop
					}, 1000);
				}

				function calculate () {
					// calculate spacer
					var windowTop = $(window).scrollTop();
					var css;

					if (windowTop < duration) {
						spacer.css({
							height: spacerInner.height()
						});

						spacerInner.addClass("fixed").css({
							top: $(slider).height() + $("header").height() + $(".cookie-policy:visible").outerHeight()
						});
					} else {
						spacer.css({
							height: "auto"
						});
						
						spacerInner.removeClass("fixed").css({
							top: "auto"
						});
					}

					// controls
					var active = getActive();

					$(".pager li", controls).removeClass("active");
					$(".pager li", controls).eq(active).addClass("active");

					$(".text", text).removeClass("active");
					$(".text", text).eq(active).addClass("active");

					if (active == 0) {
						$(".prev", controls).addClass("disabled");
					} else {
						$(".prev", controls).removeClass("disabled");
					}

					if (active == items.length - 1) {
						$(".next", controls).addClass("disabled");
					} else {
						$(".next", controls).removeClass("disabled");
					}
				}

				calculate();

				$(window).on("load scroll", function () {
					calculate();
				});

				$(".pager li", controls).on({
					click: function () {
						var index = $(this).index();
						goTo(index);
					}
				});

				$(".prev", controls).on({
					click: function () {
						if (!$(this).hasClass("disabled")) {
							var active = getActive();
							var prev = active - 1;

							if (prev >= 0) {
								goTo(prev);
							}
						}
					}
				});

				$(".next", controls).on({
					click: function () {
						if (!$(this).hasClass("disabled")) {
							var active = getActive();
							var next = active + 1;

							if (next < items.length) {
								goTo(next);
							}
						}
					}
				});
			},
			destroy: function () {
				if (main.sliders.main.controller) {
					main.sliders.main.controller.destroy(true);
					main.sliders.main.controller = null;
				}
			}
		},
		list: function (onResize) {
			$(".module-slider-list .slider .item").css({
				height: $(window).height() - $("header").height()
			});

			if (!onResize) {
				var slideSpeed = 800;

				if ($("html").hasClass("touchevents")) {
					slideSpeed = 200;
				}

				$(".module-slider-list .slider").owlCarousel({
					singleItem: true,
					navigation: true,
					navigationText: false,
					slideSpeed: slideSpeed
				});
			}
		},
		cards: function () {

			$(".module-slider-cards .slider").each(function (index, slider) {
				var items = $(slider).data("items");
				var items_sm = $(slider).data("items-sm");
				var items_xs = $(slider).data("items-xs");

				if (!items_sm) {
					items_sm = items;
				}

				if (!items_xs) {
					items_xs = items_sm;
				}

				// if(items == 2 && $(".item", slider).length < 2 && windowWidth >= 768){
				// 	$(slider).addClass("single two");
				// }
				//
				// if(items == 4 && $(".item", slider).length < 4 && windowWidth >= 768){
				// 	$(slider).addClass("single four");
				// }

				var slideSpeed = items * 150;

				if ($("html").hasClass("touchevents")) {
					slideSpeed = 200;
				}

				$(slider).owlCarousel({
					items: items,
					itemsDesktop: false,
					itemsTablet: false,
					itemsTabletSmall: false,
					itemsMobile: false,
					itemsCustom: [
						[0, items_xs],
						[768, items_sm],
						[992, items]
					],
					navigation: true,
					navigationText: false,
					scrollPerPage: true,
					slideSpeed: slideSpeed
				});

				sliderResize();
			});

			function sliderResize () {
				$(window).off("resize").resize(function() {
					var windowWidth = $(window).width();

					$(".module-slider-cards .slider").each(function (index, slider) {
						var items = $(slider).data("items");

						if(items == 2 && $(".item", slider).length < 2 && windowWidth >= 768){
							$(slider).addClass("singleTwo");
						} else {
							$(slider).removeClass("singleTwo");
						}

						if(items == 4 && $(".item", slider).length < 4 && windowWidth >= 768){
							$(slider).addClass("singleFour");
						} else {
							$(slider).removeClass("singleFour");
						}
					});

				}).trigger("resize");
			}
		},
		gallery: function (onResize) {
			var sliderMain = $(".module-slider-gallery .slider .main");
			var sliderThumbnails = $(".module-slider-gallery .slider .thumbnails");

			if (!onResize) {
				$(".item", sliderMain).each(function () {
					var thumbnail = $(this).data("thumbnail");

					sliderThumbnails.append('<div class="item"><figure><img src="' + thumbnail + '" alt=""></figure></div>');
				});

				var slideSpeed = 800;

				if ($("html").hasClass("touchevents")) {
					slideSpeed = 200;
				}

				if ($(".item", sliderThumbnails).length < 8) {
					sliderThumbnails.addClass("centered");
				}

				sliderThumbnails.owlCarousel({
					items: 8,
					itemsDesktop: false,
					itemsDesktopSmall: false,
					itemsTablet: false,
					navigation: true,
					pagination: false,
					navigationText: false,
					scrollPerPage: true,
					slideSpeed: slideSpeed
				});

				sliderMain.owlCarousel({
					singleItem: true,
					navigation: true,
					pagination: false,
					navigationText: false,
					slideSpeed: slideSpeed,
					afterAction: function () {
						var current = this.currentItem;

						$(".owl-item", sliderThumbnails).removeClass("active");
						$(".owl-item", sliderThumbnails).eq(current).addClass("active");

						if ($.inArray(current, sliderThumbnails.data("owlCarousel").owl.visibleItems) < 0) {
							sliderThumbnails.data("owlCarousel").goTo(current);
						}

						// lazy load
						var _owl = this;

						$.each(_owl.owl.visibleItems, function (index, itemIndex) {
							var item = $(".item", _owl.owl.owlItems[itemIndex]);
							var bg = item.data("image");

							item.addClass("loaded").css({
								backgroundImage: "url('" + bg + "')"
							});
						});
					}
				});

				$(".owl-item", sliderThumbnails).on({
					click: function () {
						var index = $(this).data("owlItem");

						sliderMain.data("owlCarousel").goTo(index);
					}
				});
			}

			$(".item", sliderMain).css({
				height: $(window).height() - $(".module-content-nav").height() - 36
			});
		},
		cast: function () {
			var sliderMain = $(".module-cast .slider .main");
			var sliderThumbnails = $(".module-cast .slider .thumbnails");

			var slideSpeed = 800;

			if ($("html").hasClass("touchevents")) {
				slideSpeed = 200;
			}

			sliderThumbnails.owlCarousel({
				items: 5,
				itemsDesktop: false,
				itemsDesktopSmall: false,
				itemsTablet: false,
				itemsCustom: [
					[0, 1],
					[768, 3],
					[992, 4],
					[1200, 5]
				],
				navigation: true,
				pagination: false,
				navigationText: false,
				scrollPerPage: true,
				slideSpeed: slideSpeed
			});

			sliderMain.owlCarousel({
				singleItem: true,
				pagination: false,
				slideSpeed: slideSpeed,
				afterAction: function () {
					var current = this.currentItem;

					$(".owl-item", sliderThumbnails).removeClass("active");
					$(".owl-item", sliderThumbnails).eq(current).addClass("active");

					if ($.inArray(current, sliderThumbnails.data("owlCarousel").owl.visibleItems) < 0) {
						sliderThumbnails.data("owlCarousel").goTo(current);
					}
				},
				afterMove: function () {
					$(".module-cast .slider .main .content").each(function (index, element) {
						var content = $(element);
						var more = $(".read-more", content);
						var text1 = more.data("text1");

						content.removeClass("active");
						$("span", more).text(text1);
					});
				}
			});

			$(".owl-item", sliderThumbnails).on({
				click: function () {
					var index = $(this).data("owlItem");

					sliderMain.data("owlCarousel").goTo(index);
				}
			});

			$(".module-cast .slider .main .content").each(function (index, element) {
				var content = $(element);
				var text = $(".text", content);
				var more = $(".read-more", content);

				if (text[0].scrollHeight < text.height() + 50) {
					content.addClass("more-hidden");
				}

				more.on({
					click: function () {
						var text1 = $(this).data("text1");
						var text2 = $(this).data("text2");

						if (content.hasClass("active")) {
							$("html, body").stop().animate({
								scrollTop: $(".module-cast").offset().top - $("header .inner").height() - $(".module-content-nav").height()
							}, 500, function () {
								content.removeClass("active");
								$("span", more).text(text1);
							});
						} else {
							content.addClass("active");
							$("span", this).text(text2);
						}
					}
				});
			});
		}
	},
	promo: function () {
		var height = $(window).height() - $("header").height();

		if ($(window).width() >= 768) {
			height -= $(".module-content-nav").height();
		}

		$(".module-promo-detail").css({
			height: height
		});
	},
	backgroundImage: function (container) {
		if (!container) {
			container = "body";
		}

		$("[data-bg]", container).each(function (index, element) {
			var image = $(element).data("bg");
			var imageMobile = $(element).data("bg-mobile");
			var bg = image;

			if ($(window).width() < 768 && imageMobile) {
				bg = imageMobile;
			}

			if (bg) {
				$(element).css({
					backgroundImage: "url(" + bg + ")"
				});
			}

			$("<img/>").attr("src", bg).on({
				load: function () {
					$(this).remove();

					$(element).addClass("bg-loaded");
				}
			});
		});
	},
	contentNav: function () {
		$(".module-content-nav ul").niceScroll({
			touchbehavior: true,
			cursoropacitymax: 0
		});

		$(".module-content-nav ul").on({
			scroll: function () {
				var container = $(this).parents(".container");
				var innerWidth = 0;
				var scrollLeft = $(this).scrollLeft();

				$("li", this).each(function (index, element) {
					innerWidth += $(element).width();
				});

				if (scrollLeft > 0) {
					container.addClass("gradient-left");
				} else {
					container.removeClass("gradient-left");
				}

				if (innerWidth - $(this).width() <= scrollLeft) {
					container.removeClass("gradient-right")
				} else {
					container.addClass("gradient-right")
				}
			}
		}).trigger("scroll");

		$(window).on({
			resize: function () {
				$(".module-content-nav ul").trigger("scroll");
			}
		});

		if ($(".module-content-nav.has-sticky").length) {
			$(window).on({
				scroll: function () {
                    var navTop = $(".module-content-nav.has-sticky").offset().top - $(window).scrollTop();

                    if($(".cookie-policy").is(":visible") && $(window).width() < 992 ){
                        var cookieHeight = $(".cookie-policy:visible").outerHeight(),
                            totalHeight = cookieHeight + 36,
                    		navTop = $(".module-content-nav.has-sticky").offset().top - totalHeight - $(window).scrollTop();
					}

					$(".module-content-nav.has-sticky").removeClass("menu-opened");

					if (navTop <= 0 && $(window).width() >= 375) {
						$(".module-content-nav.has-sticky").addClass("sticky");
						$("header .search").removeClass("active");
						$("header .search-container").removeClass("active");
						$(".search-overlay").removeClass("active");

						if (!$("header nav").hasClass("opened")) {
							$("header").addClass("collapsed");
						}
					} else {
						$(".module-content-nav.has-sticky").removeClass("sticky");
						$("header").removeClass("collapsed");
					}
				}
			});

			$(".module-content-nav.has-url a").on({
				click: function (event) {
					var url = $(this).attr("href").replace("#", "");
					var scrollTop = $("[data-url='" + url + "']").offset().top - $(".module-content-nav.has-url").height() + 1;

					if ($(window).width() >= 375) {
						scrollTop -= 36;
					}

					$("html, body").stop().animate({
						scrollTop: scrollTop
					}, 500);
				}
			});

			if ($(".module-content-nav.has-url").length) {
				$(window).on({
					scroll: function () {
						var elements = [];

						$("[data-url]").each(function (index, element) {
							console.log($(element).data('url') );
							if ($(element).data('url').indexOf('ajax') < 0) {
								if ($(window).scrollTop() + $(".module-content-nav.has-url").height() + 36 >= $(element).offset().top) {
									elements.push(element);
								}
							}
						});

						$(".module-content-nav.has-url a").removeClass("active");

						if (elements.length) {
							var activeElement = elements[elements.length - 1];
							var url = $(activeElement).data("url");

							var activeButton = $(".module-content-nav.has-url a[href='#" + url + "']");

							var width = activeButton.outerWidth(true);
							var offset = activeButton.length ? activeButton.position().left : 0;
							var scrollLeft = $(".module-content-nav ul").scrollLeft();
							var scrollTo = (scrollLeft + offset) - ($(".module-content-nav ul").width() / 2) + (width / 2);

							$(".module-content-nav ul").getNiceScroll(0).doScrollLeft(scrollTo, 0);
							
							activeButton.addClass("active");

							history.replaceState(undefined, undefined, "#" + url);
						} else {
							history.replaceState(undefined, undefined, "");
						}
					},
					load: function () {
						var hash = window.location.hash.replace("#", "");

						if (hash) {
							$(".module-content-nav.has-url a[href='#" + hash + "']").trigger("click");
						}
					}
				});
			}
		}

		$(".module-content-nav a.filter").on({
			click: function (event) {
				var width = $(this).outerWidth(true);
				var offset = $(this).position().left;
				var scrollLeft = $(".module-content-nav ul").scrollLeft();
				var scrollTo = (scrollLeft + offset) - ($(".module-content-nav ul").width() / 2) + (width / 2);
				var value = $(this).data("value");

				$(this).parents(".module-content-nav").find("a.filter").removeClass("active");
				$(this).addClass("active");

				$(".module-content-nav input[type='hidden']").val(value).trigger("change");

				$(".module-content-nav ul").getNiceScroll(0).doScrollLeft(scrollTo, 0);

				$(".module-slider-list[data-category]").hide();
				$(".module-slider-list[data-category='" + value + "']").show( 0, function () {
					if (!event.isTrigger) { // fix
						$("html, body").stop().animate({
							scrollTop: $(".module-content-nav").offset().top - $("header").outerHeight()
						}, 800);
					}
                });


				event.preventDefault();
			}
		});

		$(".module-content-nav a.filter.active").trigger("click");
	},
	eventCalendar: function () {
		var calendar = $(".module-event-calendar .calendar");
		var templateURL = calendar.data("mobile-template");
		var listURL = calendar.data("list");
		var mobileItems = $(".module-event-calendar .mobile-items");
		var mobileError = $(".module-event-calendar .mobile-error");

		var cellSize = function () {
			var cellHeight = (calendar.width() / 7) - $(".fc-day-number", calendar).outerHeight()

			$("head #cell-height").remove();
			
			$("head").append('<style id="cell-height" type="text/css">.module-event-calendar .calendar .fc-view .fc-body tbody td:empty {height: ' + cellHeight + 'px;}</style>');
		}

		if (mobileItems.length) {
			var template;

			$.ajax({
				type: "GET",
				url: templateURL,
				async: false,
				success: function (response) {
					template = response;
				}
			});
		}

		var lightboxArr;

		calendar.fullCalendar({
			events: function (start, end, timezone, callback) {
				var startDate = moment(start).format("YYYY-MM-DD");
				var endDate = moment(end).format("YYYY-MM-DD");

				var data = $(".module-event-calendar .filters :input").serialize();
				data += "&start=" + startDate + "&end=" + endDate;

				$.ajax({
					type: "GET",
					url: listURL,
					async: false,
					dataType: "json",
					data: data,
					success: function (response) {
						var events = [];
						lightboxArr = [];

						$.each(response.data, function (index, event) {
							events.push({
								index: index,
								title: event.title,
								start: event.date.full,
								type:  event.type,
								calendar:event.isPastCalender
							});
							//console.log(event.isPastCalender);

							lightboxArr.push({
								href: event.lightbox
							});
						});

						callback(events);

						if (events.length) {
							var output = Mustache.render(template, response);
							mobileItems.html(output);
							mobileError.text("");
						} else {
							mobileItems.html("");
							mobileError.text(response.errorText);
						}
					}
				});
			},
			columnFormat: "dddd",
			fixedWeekCount: false,
			header: false,
			height: "auto",
			lang: $("html").attr("lang"),
			eventRender: function (event, element, view) {
				var type = event.type;
				var title = event.title;
				var time = moment(event.start).format("HH:mm");
				var response = event.calendar;
				if (response){
					return '<div class="event"><h4 class="disabled">' + type + '</h4><h3 class="disabled">' + title + '</h3><div class="time disabled">' + time + '</div></div>';
				}else{
					return '<div class="event"><h4>' + type + '</h4><h3>' + title + '</h3><div class="time">' + time + '</div></div>';
				}
			},
			eventClick: function (event) {
				var index = event.index;

				$.fancybox(lightboxArr, {
					index: index,
					type: "ajax",
					width: "100%",
					height: "auto",
					maxWidth: 370,
					padding: 0,
					fitToView: false,
					autoSize: false,
					scrolling: "no",
					autoCenter: true
				});
			},
			viewRender: function (view, element) {
				var date = view.intervalStart;
				var prevMonthName = moment(date).subtract(1, "months").format("MMMM");
				var nextMonthName = moment(date).add(1, "months").format("MMMM");
				var month = moment(date).format("MM");
				var year = moment(date).format("YYYY");

				$(".module-event-calendar .head .prev span").text(prevMonthName);
				$(".module-event-calendar .head .next span").text(nextMonthName);
				$(".module-event-calendar .head .month").val(month).trigger("change.select2");
				$(".module-event-calendar .head .year").val(year).trigger("change.select2");

				cellSize();
			},
			windowResize: function () {
				cellSize();
			}
		});

		$(".module-event-calendar .filters :input").on("change ifChecked", function () {
			calendar.fullCalendar("refetchEvents");
		});

		$(".module-event-calendar .head .prev").on({
			click: function () {
				calendar.fullCalendar("prev");
			}
		});

		$(".module-event-calendar .head .next").on({
			click: function () {
				calendar.fullCalendar("next");
			}
		});

		$(".module-event-calendar .head select").on({
			change: function () {
				var month = $(".module-event-calendar .head .month").val();
				var year = $(".module-event-calendar .head .year").val();

				calendar.fullCalendar("gotoDate", year + "-" + month + "-01");
			}
		});
	},
	customInputs: function () {
		if ($("html").hasClass("no-touchevents") || $(window).width() >= 768) {
			$("select").each(function (index, element) {
				if($(element).attr("name") == "district"){
					$(element).select2({
						"language": {
							"noResults": function(){
								var errorsText;
								if($("html").attr("lang") == "tr"){
									errorsText = "Sonuç bulunamadı"
								} else {
									errorsText = "No Results Found"
								}

								if($(element).attr("name") == "district" && $(element).parents(".discount-form").length && $("html").attr("lang") == "tr"){
									if($(element).parents(".row").find("select[name='city']").val() == ""){
										errorsText = "Şehir Seçiniz"
									}
								}

								return errorsText;
							}
						},
						dropdownAutoWidth: true,
						dropdownParent: $(element).parent()
					});
				} else {
					$(element).select2({
						"language": {
							"noResults": function(){
								var errorsText;
								if($("html").attr("lang") == "tr"){
									errorsText = "Sonuç bulunamadı"
								} else {
									errorsText = "No Results Found"
								}

								if($(element).attr("name") == "district" && $(element).parents(".discount-form").length && $("html").attr("lang") == "tr"){
									if($(element).parents(".row").find("select[name='city']").val() == ""){
										errorsText = "Şehir Seçiniz"
									}
								}

								return errorsText;
							}
						},
						minimumResultsForSearch: Infinity,
						dropdownAutoWidth: true,
						dropdownParent: $(element).parent()
					});
				}

			});
			
			$("select").on("select2:open", function (event) {
				$(".select2-results__options").niceScroll({
					autohidemode: false,
					cursorborder: 0
				});
			});
		}

		$("input").iCheck();

		$("input").on({
			ifChanged: function () {
				if ($(this).is(":checked")) {
					$(this).parents("label").addClass("checked");
				} else {
					$(this).parents("label").removeClass("checked");
				}
			}
		}).trigger("ifChanged");

		$(".input-1").each(function (index, element) {
			$("input", element).on({
				keyup: function () {
					var length = $(this).val().length;

					if (length == 0) {
						$(".remove", element).hide();
					} else {
						$(".remove", element).show();
					}
				}
			}).trigger("keyup");

			$(".remove", element).on({
				click: function () {
					$("input", element).val("").trigger("focus").trigger("keyup");
				}
			});
		})

		$(".input-2").each(function (index, element) {
			var input = $("input", element);
			var placeholder = $(".placeholder", element);

			input.on({
				focusin: function () {
					placeholder.addClass("focus");
				},
				focusout: function () {
					if (input.val() == "") {
						placeholder.removeClass("focus");
					} else {
						placeholder.addClass("focus");
					}
				}
			}).trigger("focusout");
		});

		$(".submit").on({
			click: function () {
				$(this).parents("form").submit();
			}
		});
	},
	lightbox: function () {

		/* fancybox-all-dates için kullanıldı */
		var windowWidth = $(window).outerWidth();
		var maxHeight = "80%";
		if(windowWidth < 768){
			var maxHeight = "100%";
		}
		/* fancybox-all-dates için kullanıldı */

		// Ticket & sessions
		var sessions = ".lightbox-ticket .sessions";

		var templateURL, listURL, template;

		var getTemplate = function () {
			templateURL = $(sessions).data("template");
			listURL = $(sessions).data("list");

			$.ajax({
				type: "GET",
				url: templateURL,
				async: false,
				success: function (response) {
					template = response;
				}
			});
		}

		var getSessions = function () {
			var data = $(".form :input", sessions).serialize();

			$.ajax({
				type: "GET",
				url: listURL,
				async: false,
				dataType: "json",
				data: data,
				success: function (response) {
					var output = Mustache.render(template, response);
					$(".items", sessions).html(output);
				}
			});
		}

        $(".fancybox-genc-yetenek").fancybox({
            width: "100%",
            height: "100%",
            maxWidth: 720,
            maxHeight: 600,
            margin: 0,
            padding: 0,
            fitToView: false,
            autoSize: false,
            wrapCSS: "fancybox-skin-2",
            autoCenter: true
        });

		$(".fancybox-ticket").fancybox({
			width: "100%",
			height: "100%",
			maxWidth: 720,
			maxHeight: 600,
			margin: 0,
			padding: 0,
			fitToView: false,
			autoSize: false,
			wrapCSS: "fancybox-skin-2",
			autoCenter: true,
			beforeShow: function () {
				if ($(sessions).length) {
					getTemplate();
				}
				
				main.customInputs();

				$(".form input[type='radio']:checked", sessions).trigger("ifChecked");

				if ($("html").hasClass("no-touchevents")) {
					$(".lightbox-ticket .contents").niceScroll({
						autohidemode: false,
						cursorborder: 0
					});
				}

				$(".lightbox-ticket .tabs li.active").trigger("click");
			}
		});

		$("body").on("click", ".lightbox-ticket .tabs li", function () {
			$(this).parents(".tabs").find("li").removeClass("active");
			$(this).addClass("active");

			var index = $(this).index();

			$(".lightbox-ticket .contents .content").hide();
			$(".lightbox-ticket .contents .content").eq(index).show();
		});

		$("body").on("ifChecked", sessions + " .form input[type='radio']", function () {
			var select = $(this).data("select");

			$(".form .select-content", sessions).hide();
			$(".form .select-content[data-select='" + select + "']", sessions).show();
		});

		$("body").on("change", sessions + " .form select[name='city']", function () {
			var data = $(this).serialize();
			var url = $(this).data("url");
			var district = $(".form select[name='district']", sessions);

			$.ajax({
				type: "GET",
				url: url,
				async: false,
				dataType: "json",
				success: function (response) {
					district.html('<option value="">' + district.data("placeholder") + '</option>');

					$.each(response.data, function (index, element) {
						district.append('<option value="' + element.id + '">' + element.name + '</option>');
					});

					district.trigger("change.select2");
				}
			});
		});

		$("body").on("change ifChecked", ".lightbox-ticket .sessions .form :input", function () {
			getSessions();
		});

		// Cast mobile
		$(".module-cast .mobile a").fancybox({
			type: "ajax",
			width: "100%",
			height: "100%",
			margin: 0,
			padding: 0,
			fitToView: false,
			autoSize: false,
			wrapCSS: "fancybox-skin-2",
			arrows: false,
			autoCenter: true,
			afterShow: function () {
				$(".fancybox-wrap").swipe({
					swipeLeft: function () {
						$.fancybox.next();
					},
					swipeRight: function () {
						$.fancybox.prev();
					}
				});
			}
		});

		$("body").on("click", ".lightbox-cast .image .prev", function () {
			$.fancybox.prev();
		});

		$("body").on("click", ".lightbox-cast .image .next", function () {
			$.fancybox.next();
		});

		// Maps
		$("body").on("click", ".fancybox-maps", function (event) {
			var href = $(this).data("fancybox-href");

			if ($(window).width() > 568) {
				$.fancybox({
					href: href,
					type: "iframe",
					width: 800,
					height: 450,
					padding: 0,
					aspectRatio: true,
					autoCenter: true
				});

				event.preventDefault();
			}
		});

		// Gallery
		$(".fancybox-gallery").fancybox({
			width: 1200,
			height: 674,
			maxHeight: "90%",
			padding: 0,
			aspectRatio: true,
			autoCenter: true
		});

		// All dates
		$(".fancybox-all-dates").fancybox({
			type: "ajax",
			width: "100%",
			height: "auto",
			maxWidth: 720,
			maxHeight: maxHeight,
			margin: 0,
			padding: 0,
			fitToView: false,
			autoSize: false,
			wrapCSS: "fancybox-skin-2",
			autoCenter: true,
			beforeShow: function () {
				if ($("html").hasClass("no-touchevents")) {
					$(".lightbox-all-dates .content").niceScroll({
						autohidemode: false,
						cursorborder: 0
					});
				}
			}
		});

		// Announcement
		if (!Cookies.get("announcementDisabled")) {
			var announcement = $("body").data("announcement");

			if (announcement) {
				$.fancybox({
					href: announcement,
					maxWidth: "90%",
					maxHeight: "90%",
					padding: 0,
					afterClose: function () {
						Cookies.set("announcementDisabled", true, {expires: 1});
					}
				});
			}
		}
	},
	feeds: function () {
		if ($(".module-social-feed .feeds").length) {
			var feed = $(".module-social-feed .feeds").packery({
				itemSelector: ".item"
			});

			feed.imagesLoaded().progress(function () {
				feed.packery();
			});
		}
	},
	synopsis: function () {
		$(".module-synopsis .content").each(function (index, element) {
			var content = $(element);
			var text = $(".text", content);
			var more = $(".read-more", content);

			if (text[0].scrollHeight < text.height() + 50) {
				content.addClass("more-hidden");
			}

			more.on({
				click: function () {
					var text1 = $(this).data("text1");
					var text2 = $(this).data("text2");

					if (content.hasClass("active")) {
						$("html, body").stop().animate({
							scrollTop: $(".module-synopsis").offset().top - $("header .inner").height() - $(".module-content-nav").height()
						}, 500, function () {
							content.removeClass("active");
							$("span", more).text(text1);
						});
					} else {
						content.addClass("active");
						$("span", this).text(text2);
					}
				}
			});
		});
	},
	director: function () {
		$(".module-director .content").each(function (index, element) {
			var content = $(element);
			var text = $(".text", content);
			var more = $(".read-more", content);

			if (text[0].scrollHeight < text.height() + 50) {
				content.addClass("more-hidden");
			}

			more.on({
				click: function () {
					var text1 = $(this).data("text1");
					var text2 = $(this).data("text2");

					if (content.hasClass("active")) {
						$("html, body").stop().animate({
							scrollTop: $(".module-director").offset().top - $("header .inner").height() - $(".module-content-nav").height()
						}, 500, function () {
							content.removeClass("active");
							$("span", more).text(text1);
						});
					} else {
						content.addClass("active");
						$("span", this).text(text2);
					}
				}
			});
		});
	},
	pagination: function () {
		$(".pagination").each(function (index, pagination) {
			$("select", pagination).on({
				change: function () {
					var prev = $("option:selected", this).prev("option");
					var next = $("option:selected", this).next("option");

					if (prev.length) {
						$(".prev", pagination).removeClass("disabled");
					} else {
						$(".prev", pagination).addClass("disabled");
					}

					if (next.length) {
						$(".next", pagination).removeClass("disabled");
					} else {
						$(".next", pagination).addClass("disabled");
					}
				}
			}).trigger("change");

			$(".prev", pagination).on({
				click: function () {
					var select = $("select", pagination);
					var prev = $("option:selected", select).prev("option");

					if (prev.length) {
						prev.prop("selected", true);
						select.trigger("change");
					}
				}
			});

			$(".next", pagination).on({
				click: function () {
					var select = $("select", pagination);
					var next = $("option:selected", select).next("option");

					if (next.length) {
						next.prop("selected", true);
						select.trigger("change");
					}
				}
			});
		});
	},
	list: function (container) {
		var isInfinite = false;

		if ($(container).length) {
			var templateURL = $(container).data("template");
			var listURL = $(container).data("list");

			if ($(container).is(".module-list-events")) {
				infiniteBinder(true);
			}

			// template
			var deferredTemplate = $.ajax({
				type: "GET",
				url: templateURL
			});

			// list
			var getList = function (pagination) {
				if (!(pagination && isInfinite) && $(window).scrollTop() > 0) {
					$("html, body").stop().animate({
						scrollTop: $(".module-content-nav").next().offset().top - $(".module-content-nav").height() - 35
					}, 800);
				}

				if (!pagination) {
					$(".pagination select", container).val("1").data("value", "1");
				}

				var category = $(".module-content-nav :input").serialize();
				var filters = $(":input", container).serialize();
				var data = category + "&" + filters;

				if (pagination && isInfinite) {
					$(".loading-bottom", container).addClass("active");
				} else {
					$(".loading-top", container).addClass("active");
				}

				$(container).addClass("loading");

				var deferredData = $.ajax({
					type: "GET",
					url: listURL,
					dataType: "json",
					data: data
				});

				$.when(deferredTemplate, deferredData)
					.done(function (template, data) {
						$(".loading-top", container).removeClass("active");
						$(".loading-bottom", container).removeClass("active");
						$(container).removeClass("loading");

						// title
						$(".page-sub-heading", container).html(data[0].pageTitle);

						if(data[0].url){
							history.replaceState(null, null, data[0].url);
						}

						// items
						if (data[0].data.length) {
							var output = Mustache.render(template[0], data[0]);

							$(".error-text", container).text("").hide();

							if (pagination && isInfinite) {
								$(".items", container).append(output).show();
							} else {
								$(".items", container).html(output).show();
							}

							main.backgroundImage($(".items", container));

							if (data[0].pages > 1 && !isInfinite) {
								$(".pagination", container).show();
							} else {
								$(".pagination", container).hide();
							}

							if (data[0].data.length < 4) {
								$(container).addClass("centered");
							} else {
								$(container).removeClass("centered");
							}
						} else {
							$(".items", container).html("").hide();
							$(".error-text", container).text(data[0].errorText).show();

							$(".pagination", container).hide();
						}

						// pagination
						if (!pagination) {
							$(".pagination select", container).html("");

							for (var i = 1; i <= data[0].pages; i++) {
								$(".pagination select", container).append('<option value="' + i + '">' + i + '</option>');
							}

							$(".pagination select", container).trigger("change");
						}
					})
			};

			getList();

			// events
			$(".module-content-nav :input").on({
				change: function (event) {
					$(".filters form", container)[0].reset();
					$(".filters form input", container).iCheck("update");
					
					getList();
				}
			});

			$(".filters form", container).on({
				submit: function (event) {
					event.preventDefault();
				}
			});

			$(".filters :input", container).on("change ifChecked", function () {
				getList();
			});

			$(".select-date :input", container).on("change", function () {
				var value = $(this).val();

				infiniteBinder(value == "guncel");
			});

			// keyword event
			var timer;

			$(".filters input[name='search_keyword']", container).unbind("change").on({
				keyup: function (event) {
					if ($(this).val().length >= 3 || $(this).val() == "") {
						clearTimeout(timer);

						timer = setTimeout(function () {
							getList();
						}, 500);
					}
				}
			});

			// pagination event
			$(".pagination select", container).on({
				change: function () {
					if ($(this).val() && $(this).val() != $(this).data("value")) {
						$(this).data("value", $(this).val());

						getList(true);
					}
				}
			});
		}

		// infinite
		var infiniteTimer;

		function infinite () {
			var scrollTop = $(window).scrollTop();
			var windowHeight = $(window).height();
			var infiniteOffset = $(".infinite", container).offset().top + 20;

			if ((scrollTop + windowHeight > infiniteOffset) && !$(container).hasClass("loading")) {
				clearTimeout(infiniteTimer);

				infiniteTimer = setTimeout(function () {
					$(".pagination .next").trigger("click");
				}, 200);
			}
		}

		function infiniteBinder (isBind) { // true: bind, false: unbind
			isInfinite = isBind;

			if (isBind) {
				$(window).bind("scroll", infinite);
			} else {
				$(window).unbind("scroll", infinite);
			}
		}
	},
	search: function () {
		var search = $(".search-container");
		var searchOverlay = $(".search-overlay");

		function open () {
			$("input", search).trigger("focus");

			$("header .search").addClass("active");
			search.addClass("active");
			searchOverlay.addClass("active");
		}

		function close () {
			$("header .search").removeClass("active");
			search.removeClass("active");
			searchOverlay.removeClass("active");

			$("input", search).val("").trigger("keyup").trigger("blur");
		}

		$("header .search").on({
			click: function () {
				if (!$(".page-search-results").length) {
					open();
				}
			}
		});

		$("header .bar .bar-search").on({
			click: function () {
				$("header").removeClass("collapsed");
				$(".module-content-nav.has-sticky").addClass("menu-opened");

				setTimeout(function () {
					$("header .search").trigger("click");
				}, 100);
			}
		});

		$(window).on({
			click: function (event) {
				var target = $(event.target);

				if (!(target.is(search) || target.parents(".search-container").length || target.is(".search") || target.parents(".search").length || $(".page-search-results").length)) {
					close();
				}
			},
			keyup: function (event) {
				if (event.keyCode == 27) {
					close();
				}
			},
			keydown: function (event) {
				if(!$(".discount-form").length){
					var target = $(event.target);

					if (!(event.keyCode == 27 || event.keyCode == 9 || target.is(":input") || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || $(".page-search-results").length || $(".fancybox-overlay").length || $(".side-content-overlay").hasClass("active"))) {
						$("header").removeClass("collapsed");
						$(".module-content-nav.has-sticky").addClass("menu-opened");

						open();
					}
				}
			}
		});

		$("input", search).on({
			keyup: function () {
				var length = $(this).val().length;

				if (length == 0) {
					$(".remove", search).removeClass("active");
				} else {
					$(".remove", search).addClass("active");
				}
			}
		}).trigger("keyup");

		$(".remove", search).on({
			click: function () {
				$("input", search).val("").trigger("focus").trigger("keyup");
			}
		});

		$("form", search).each(function (index, element) {
			$(element).validate({
				errorPlacement: function (error, element) {}, // remove error labels
				highlight: function(element, errorClass, validClass) {
					$(element).parent().addClass(errorClass).removeClass(validClass);
				},
				unhighlight: function(element, errorClass, validClass) {
					$(element).parent().removeClass(errorClass).addClass(validClass);
				},
				rules: {
					search: {
						required: true,
						minlength: 3
					}
				}
			});
		});

		$(window).on("mousewheel touchmove", function (event) {
			if ($(".search-overlay").hasClass("active")) {
				event.preventDefault();
			}

			if ($(event.target).is(".side-content-overlay")) {
				event.preventDefault();
			}
		});
	},
	share: {
		popup: function (url) {
			var D = 550, A = 450, C = screen.height, B = screen.width, H = Math.round((B / 2) - (D / 2)), G = 0;
			window.open(url, '', 'left=' + H + ',top=' + G + ',width=' + D + ',height=' + A + ',personalbar=0,toolbar=0,scrollbars=1,resizable=1');
		},
		facebook: function () {
			var url = window.location.href;

			main.share.popup("http://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url));
		},
		twitter: function (text) {
			var url = window.location.href;

			main.share.popup("http://twitter.com/intent/tweet?text=" + encodeURIComponent(text) + " - " + encodeURIComponent(url));
		},
		init: function () {
			$(".social-widget > ul > li > a").on({
				click: function (event) {
					var container = $(this).parent();

					if (container.hasClass("active")) {
						container.removeClass("active");
					} else {
						$(".social-widget > ul > li").removeClass("active");
						container.addClass("active");
					}

					event.preventDefault();
				}
			});

			$(window).on({
				click: function (event) {
					if (!$(event.target).parents(".social-widget").length) {
						$(".social-widget > ul > li").removeClass("active");
					}
				}
			});

			$(".social-widget .share a.facebook-ico").on({
				click: function (event) {
					main.share.facebook();

					event.preventDefault();
				}
			});

			$(".social-widget .share a.twitter-ico").on({
				click: function (event) {
					var text = $(this).data("text");
					var hashtag = $(this).data("hashtag");

					main.share.twitter(text + " " + hashtag);

					event.preventDefault();
				}
			});

			// Mobile band
			var controller = new ScrollMagic.Controller();

			var scene = new ScrollMagic.Scene({
				duration: function () {
					return $(".mobile-band").offset().top + $(".mobile-band").height() - $(".module-promo-detail .text .buttons").offset().top - $(window).height();
				},
				triggerHook: 0,
				triggerElement: ".module-promo-detail .text .buttons"
			})
			.setClassToggle(".mobile-band", "active")
			.addTo(controller);


			$(".mobile-band .social > ul > li > a").on({
				click: function (event) {
					var container = $(this).parent();

					if (container.hasClass("active")) {
						container.removeClass("active");
					} else {
						$(".mobile-band .social > ul > li").removeClass("active");
						container.addClass("active");
					}

					event.preventDefault();
				}
			});

			$(window).on({
				click: function (event) {
					if (!$(event.target).parents(".mobile-band").length) {
						$(".mobile-band .social > ul > li").removeClass("active");
					}
				},
				scroll: function () {
					$(".mobile-band .social > ul > li").removeClass("active");
				}
			});

			$(".mobile-band .share a.facebook-ico").on({
				click: function (event) {
					main.share.facebook();

					event.preventDefault();
				}
			});

			$(".mobile-band .share a.twitter-ico").on({
				click: function (event) {
					var text = $(this).data("text");

					main.share.twitter(text);

					event.preventDefault();
				}
			});
		}
	},
	tooltip: function () {
		function create (element) {
			$(element).qtip({
				content: $(element).html(),
				position: {
					my: "bottom center",
					at: "top center"
				},
				style: {
					width: $(element).width(),
					tip: {
						width: 9,
						height: 6
					}
				}
			});
		}

		function init () {
			$(".card-movie .date, .module-cast .slider .thumbnails .item .thumbnail .text .name").each(function (index, element) {
				$(element).qtip("destroy", true);

				if (element.scrollWidth > $(element).innerWidth()) {
					create(element);
				}
			});

			$(".card-movie h3 span, .card-event-2 h3 a").each(function (index, element) {
				$(element).qtip("destroy", true);

				if ($(element).height() > $(element).parent().height()) {
					create(element);
				}
			});
		}

		init();


		var timer;

		$(window).on({
			resize: function () {
				clearTimeout(timer);

				timer = setTimeout(function () {
					init();
				}, 200);
			}
		});
	},
	isMobile: {
		Android: function () {
			return navigator.userAgent.match(/Android/i);
		},
		BlackBerry: function () {
			return navigator.userAgent.match(/BlackBerry/i);
		},
		iOS: function () {
			return navigator.userAgent.match(/iPhone|iPad|iPod/i);
		},
		Opera: function () {
			return navigator.userAgent.match(/Opera Mini/i);
		},
		Windows: function () {
			return navigator.userAgent.match(/IEMobile/i);
		},
		any: function () {
			return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
		}
	},
	sinekafa: function () {
		if (main.isMobile.iOS()) {
			$("footer .sinekafa .buttons .android").hide();
		} else if (main.isMobile.Android()) {
			$("footer .sinekafa .buttons .ios").hide();
		}
	},
	awards: function () {
		$(".module-awards-mobile ul").niceScroll({
			touchbehavior: true,
			cursoropacitymax: 0
		});

		$(".module-awards-mobile ul").on({
			scroll: function () {
				var container = $(this).parents(".container");
				var innerWidth = 0;
				var scrollLeft = $(this).scrollLeft();

				$("li", this).each(function (index, element) {
					innerWidth += $(element).outerWidth(true);
				});

				if (scrollLeft > 0) {
					container.addClass("gradient-left");
				} else {
					container.removeClass("gradient-left");
				}

				if (innerWidth - $(this).width() - 1 <= scrollLeft) {
					container.removeClass("gradient-right")
				} else {
					container.addClass("gradient-right")
				}
			}
		}).trigger("scroll");

		$(window).on({
			resize: function () {
				$(".module-awards-mobile ul").trigger("scroll");
			}
		});
	},
	crew: function () {
		if ($(".module-crew").length) {
			$(".module-crew .text ul").packery({
				itemSelector: "li"
			});
		}
	},
	notFound: function (onResize) {
		$(".page-not-found").css({
			height: $(window).height()
		});

		if (!onResize) {
			var random = Math.floor(Math.random() * 7) + 1;

			$(".page-not-found").css({
				backgroundImage: "url('/assets/images/404/404-" + random + ".jpg')"
			});
		}
	},
	about: function () {
		$(".module-about .content").each(function (index, element) {
			var content = $(element);
			var text = $(".text", content);
			var more = $(".read-more", content);

			if (text[0].scrollHeight < text.height() + 50) {
				content.addClass("more-hidden");
			}

			more.on({
				click: function () {
					var text1 = $(this).data("text1");
					var text2 = $(this).data("text2");

					if (content.hasClass("active")) {
						$("html, body").stop().animate({
							scrollTop: $(".module-about").offset().top - $("header .inner").height() - $(".module-content-nav").height()
						}, 500, function () {
							content.removeClass("active");
							$("span", more).text(text1);
						});
					} else {
						content.addClass("active");
						$("span", this).text(text2);
					}
				}
			});
		});
	},
	sideContent: {
		open: function () {
			$(".side-content-overlay").addClass("active");
			$(".side-content").addClass("active");
		},
		close: function () {
			$(".side-content-overlay").removeClass("active");
			$(".side-content").removeClass("active");
		},
		create: function () {
			var formContent = $(".side-content .form-content");
			var agreementContent = $(".side-content .agreement-content");
			var resultContent = $(".side-content .result-content");

			if ($("html").hasClass("no-touchevents")) {
				formContent.niceScroll({
					autohidemode: false,
					cursorborder: 0
				});

				agreementContent.niceScroll({
					autohidemode: false,
					cursorborder: 0
				});
			}

			$(".agreement", formContent).on({
				click: function () {
					agreementContent.addClass("active");
				}
			});

			$(".back", agreementContent).on({
				click: function () {
					agreementContent.removeClass("active");
				}
			});

			$(".side-content .close").on({
				click: function () {
					main.sideContent.close();
				}
			});

			$.validator.addMethod("captcha", function(value, element) {
				return grecaptcha.getResponse() != "";
			}, "Lütfen doğrulama alanını işaretleyin");


			$("form", formContent).validate({
				ignore: "",
				onkeyup: false,
				highlight: function(element, errorClass, validClass) {
					$(element).parent().addClass(errorClass).removeClass(validClass);
				},
				unhighlight: function(element, errorClass, validClass) {
					$(element).parent().removeClass(errorClass).addClass(validClass);
				},
				submitHandler: function (form) {
					var url = $(form).attr("action");
					var type = $(form).attr("method");
					var data = $(form).serialize();
					$("input[type='submit']", form).attr("disabled", true);

					$.ajax({
						type: type,
						url: url,
						dataType: "json",
						data: data,
						success: function (response) {
							$("input[type='submit']", form).removeAttr("disabled");

							if (response.status == 1) {
								formContent.hide();
								resultContent.show();

								Cookies.set("landingDisabled", true, {expires: 365});
							}
						}
					});
				},
				rules: {
					name: "required",
					email: {
						required: true,
						email: true
					},
					birthDay: "required",
					birthMonth: "required",
					birthYear: "required",
					gender: "required",
					city: "required",
					phone: {
						required: true,
						number: true
					},
					campaigns: "required",
					agreement: "required",
					hiddenRecaptcha: "captcha"
				},
				messages: {
					name: "Lütfen adınızı girin",
					email: {
						required: "Lütfen e-posta adresinizi girin",
						email: "Lütfen geçerli bir e-posta adresi girin"
					},
					phone: {
						required: "Lütfen telefon numaranızı girin",
						number: "Lütfen geçerli bir telefon numarası girin"
					},
					hiddenRecaptcha: "Lütfen doğrulama alanını işaretleyin"
				}
			});
		},
		init: function () {
			var landingCount = parseInt(Cookies.get("landingCount")) || 0;
			var landingDisabled = Cookies.get("landingDisabled");

			if (landingCount >= 2) {
				Cookies.set("landingDisabled", true, {expires: 365});

				landingDisabled = true;
			}

			if (!landingDisabled) {
				main.sideContent.create();

				setTimeout(function () {
					main.sideContent.open();
					Cookies.set("landingDisabled", true);
					Cookies.set("landingCount", landingCount + 1, {expires: 365});
				}, 5000);
			}
		}
	},
    cookiePolicy:{
		init: function () {

			if (!Cookies.get("cookiePolicyDisabled")) {
                $(".cookie-policy").addClass("active");
                $(window).on("resize scroll", main.cookiePolicy.calculate).trigger("resize","scroll");

                $(".cookie-policy .close").on({
                    click: function () {
                        $(".cookie-policy").removeClass("active").hide();
                        Cookies.set("cookiePolicyDisabled", true, {expires: 365});
                        main.cookiePolicy.calculate();
                        if (main.sliders.main.scene) {
                            main.sliders.main.scene.update(true);
                        }
                    }
                });
            }
        },
		calculate: function () {
            if(($(".cookie-policy").length)){
                var cookieHeight = $(".cookie-policy:visible").outerHeight();

                if($(window).width() < 992){
                    $(".cookie-policy").css("top", 0);
                    $("header, header .inner, .module-content-nav.has-sticky .inner").removeAttr("style");
                    $("header").css("margin-top", cookieHeight).find(".inner").css("top", cookieHeight);

                    if($(".module-content-nav.has-sticky").length && $(window).width() >= 375){
                        $(".module-content-nav.has-sticky.sticky .inner").css({
                            top: cookieHeight + 36
                        });
                    }
                } else {
					$(".cookie-policy").removeAttr("style");
                    $("header, header .inner, .module-content-nav.has-sticky .inner").removeAttr("style");
                    $("header").css("margin-top", 0).find(".inner").css("top", 0);
                }
			}
        }
	},
	localization: {
		tr: [
			"Lütfen e-posta adresinizi girin",
			"Lütfen geçerli bir e-posta adresi girin"
		],
		en: [
			"Please enter a valid email address",
			"Please enter a valid email address"
		]
	},
	language: function () {
		if (!Cookies.get("langDisabled")) {
			Cookies.set("langDisabled", true);

			$.fancybox({
				href: "/assets/ajax/language.html",
				type: "ajax",
				width: "100%",
				height: "auto",
				maxWidth: 440,
				maxHeight: "100%",
				padding: 0,
				fitToView: false,
				autoSize: false,
				autoCenter: true,
				modal: true
			});
		}
	},
    discountPopUp: {
		init:function () {
            // if(!$(".not-discount-pop-up").length){
            //     var _cookieDiscount = Cookies.get("cookieDiscount");
            //
            //     if(_cookieDiscount != "true" && $("html").attr("lang") == "tr" ){
            //         $.fancybox({
            //             padding        : 0,
            //             autoScale      : false,
            //             href		   : "/assets/ajax/discount-fancy.html",
            //             type           : "ajax"
            //         });
            //         Cookies.set("cookieDiscount", "true", { expires: 1 });
            //     }
            // }
            if ($(".discount-form").length) {
            	main.discountPopUp.formValidate();
			}
        },
        formValidate: function () {

            jQuery.validator.addMethod('atLeastOneChecked', function(value, element) {
                return ($('.areasOfInterest input:checked').length > 0);
            });

            jQuery.validator.addMethod('dateOfBirth', function(value, element) {
                return (!$('.form-row-birthdate select').val() == "");
            });

            $(".discount-form").validate({
                onkeyup: false,
                highlight: function(element, errorClass, validClass) {
                    if($(element).attr("type") == "checkbox"){
                        $(element).parents(".checkboxes").addClass(errorClass).removeClass(validClass);
                    } else {
                        $(element).parent().addClass(errorClass).removeClass(validClass);
                    }
                },
                unhighlight: function(element, errorClass, validClass) {
                    if($(element).attr("type") == "checkbox"){
                        $(element).parents(".checkboxes").removeClass(errorClass).addClass(validClass);
                    } else {
                        $(element).parent().removeClass(errorClass).addClass(validClass);
                    }
                },
                rules: {
                    nameSurname: {
                        required: true
                    },
                    email: {
                        required: true,
                        email: true
                    },
                    phone: {
                        required: true,
						minlength: 17
                    },
                    yourInterests: {
                        atLeastOneChecked: true
                    },
                    agreement: "required"
                },
                groups: {
                    dateGroup: "birthDay birthMonth birthYear"
                },
                messages: {
                    nameSurname: "Lütfen adınızı ve soyadınızı girin.",
                    email: {
                        required: "Lütfen e-posta adresinizi girin.",
                        email: "Lütfen geçerli bir e-posta adresi girin"
                    },
                    phone: {
                        required: "Lütfen cep telefonu numaranızı girin.",
						minlength: "Lütfen geçerli bir cep telefonu girin"
                    },
                    birthDay: "Lütfen doğum tarihinizi girin.",
                    birthMonth: "Lütfen doğum tarihinizi girin.",
                    birthYear: "Lütfen doğum tarihinizi girin.",
					city: "Lütfen il bilgisini girin.",
					district: "Lütfen ilçe bilgisini girin.",
                    yourInterests: {
                        atLeastOneChecked: "Lütfen ilgi alanlarınızı seçin."
                    },
                    agreement: "Lütfen Kişisel Verilerin Korunması formunu okuduğunuzu onaylayın."
                },
                errorPlacement: function(error, element) {
                    var name = element.attr("name");

                    if (name == "birthDay" || name == "birthMonth" || name == "birthYear") {
                        error.insertAfter(".form-row-birthdate .row");
                    } else if(element.attr("type") == "checkbox"){
                        error.insertAfter(element.parents(".form-row"));
                    } else if(name == "city" || name == "district"){
                    	element.parents(".select-1").append(error);
					} else {
                        error.insertAfter(element);
                    }
                }
            });

            $.ajax({
                url: "/ajax/sehir-listesi",
                method: 'GET'
            }).done(function (response) {
                if (response.Status) {
                    for (var i = 0; i < response.Data.length; i++) {
                        $("select[name='city']").append($("<option></option>")
                            .attr("value", response.Data[i].name)
                            .attr("data-id", response.Data[i].id)
                            .text(response.Data[i].name));
                    }
                }
            }).error(function (response) {

            });

            $("select[name='city']").on("change", function () {
                $.ajax({
                    url: "/ajax/ilce-listesi/" + $("select[name='city'] option:selected").data("id"),
                    method: 'GET'
                }).done(function (response) {
                    $('select[name=district] option').remove();
                    if (response.Status) {
                        for (var i = 0; i < response.Data.length; i++) {
                        	var optionValue = response.Data[i].name,
								optionName = response.Data[i].name;

                        	if(optionName == "Seçiniz"){
								optionValue = ""
							}

                            $("select[name='district']").append($("<option></option>")
                                .attr("value", optionValue)
                                .text(optionName));
                        }
                    }
                    $("select[name='district']").attr("disabled", false);
                }).error(function (response) {

                });
            });
        }
	},
	inputMask:function () {

		$('#phone').mask('(500) 000 00 00', {
			'translation': {
				0: {
					pattern: /[0-9*]/
				}
			}
		});
		$('#phoneSecond').mask('+90 ### ### ## ##', {
			translation: {
				'9': null,
				'0': null,
				'#': { pattern: /[0-9]/},
			}
		});
	},
	calendarShow:function(){
		$('.module-event-calendar .head').show();
		$('.module-event-calendar .filters').show();
	},
	slideItem: function(){
		var t_slide = $('.module-slider-cards.alternate');
		var t_slide_count = t_slide.find('.owl-carousel .owl-item').length;
		t_slide.attr('data-slide-item',t_slide_count);
		if (t_slide_count==1) {
			t_slide.find('.slider').addClass('slideOne');
		}else if(t_slide_count==2){
			t_slide.find('.slider').addClass('slideTwo');
		}else{
			t_slide.find('.slider').removeClass('slideOne SlideTwo');
		}
	},
};

var checkCaptcha = function () {
	$(".g-recaptcha").parents("form").valid();
}

$(function() {
	main.navigation();
	main.newsletter();
	main.sliders.main.init();
	main.sliders.list();
	main.sliders.cards();
	main.sliders.gallery();
	main.sliders.cast();
	main.promo();
	main.backgroundImage();
	main.contentNav();
	main.eventCalendar();
	main.customInputs();
	main.lightbox();
	main.feeds();
	main.synopsis();
	main.director();
	main.pagination();
	main.search();
	main.list(".module-list-films");
	main.list(".module-list-events");
	main.list(".module-list-press-release");
	main.sinekafa();
	main.awards();
	main.crew();
	main.notFound();
	main.about();
	// main.sideContent.init();
	main.cookiePolicy.init();
	main.discountPopUp.init();
	main.inputMask();
	main.slideItem();
	$("*").on({ // iOS mouseout fix
		click: function () {
			return true;
		}
	});

	$(window).on({
		resize: function () {
			main.sliders.main.init();
			main.promo();
			main.sliders.list(true);
			main.sliders.gallery(true);
			main.backgroundImage();
			main.notFound(true);
		},
		load: function () {
			main.tooltip();
			main.share.init();
			main.calendarShow();
		}
	});
});